import { frontendURL } from '../../../../helper/URLHelper';
import SettingsContent from '../Wrapper.vue';
import Index from './Index.vue';
import PromptIndex from './PromptIndex.vue'
import NewPromptIndex from './NewPromptIndex.vue'
import ProductList from './ProductList.vue'
import OrderList from './OrderList.vue'

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/billing/configure'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'BILLING_SETTINGS.TITLE',
        // icon: 'credit-card-person',
        showNewButton: false,
        // imageUrl: '/brand-assets/settings-6-line_title'
      },
      children: [
        {
          path: '',
          name: 'billing_settings_index',
          component: Index,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/product/list'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'BILLING_SETTINGS.PRODUCT_TITLE',
        // icon: 'credit-card-person',
        showNewButton: false,
        // imageUrl: '/brand-assets/settings-6-line_title'
      },
      children: [
        {
          path: '',
          name: 'product_list_index',
          component: ProductList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/order/list'),
      meta: {
        permissions: ['administrator'],
      },
      component: SettingsContent,
      props: {
        headerTitle: 'BILLING_SETTINGS.ORDER_TITLE',
        // icon: 'credit-card-person',
        showNewButton: false,
        // imageUrl: '/brand-assets/order_title'
      },
      children: [
        {
          path: '',
          name: 'order_list_index',
          component: OrderList,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    // {
    //   path: frontendURL('accounts/:accountId/settings/billing'),
    //   meta: {
    //     permissions: ['administrator'],
    //   },
    //   component: SettingsContent,
    //   props: () => {
    //     return {
    //       headerTitle: 'BILLING_SETTINGS.TITLE',
    //       icon: 'flash-settings',
    //       showBackButton: true,
    //       showNewButton: false,
    //     };
    //   },
    //   children: [
    //     {
    //       path: 'prompts',
    //       name: 'billing_settings_prompt_list',
    //       component: PromptIndex,
    //       meta: {
    //         permissions: ['administrator'],
    //       },
    //     },
    //     {
    //       path: 'new-prompt',
    //       name: 'billing_settings_prompt_new',
    //       component: NewPromptIndex,
    //       meta: {
    //         permissions: ['administrator'],
    //       },
    //     },
    //   ],
    // },
  ],
};
